import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { ArrowLeft, Mail, MapPin, Briefcase, Calendar, Phone } from "lucide-react";
import { useNavigate } from "react-router-dom";

const Profile = () => {
  const navigate = useNavigate();

  const userInfo = {
    firstName: "John",
    lastName: "Doe",
    email: "john.doe@dislogiq.com",
    function: "Responsable Commercial",
    department: "Ventes",
    phone: "+33 1 23 45 67 89",
    address: "123 Avenue des Champs-Élysées, 75008 Paris",
    startDate: "15 Mars 2020",
    employeeId: "EMP-2020-0234"
  };

  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <div className="bg-gradient-primary relative overflow-hidden">
        <div className="absolute inset-0 bg-black/10" />
        <div className="relative max-w-4xl mx-auto px-6 py-12">
          <div className="flex items-center gap-4 mb-8">
            <Button
              variant="ghost"
              size="sm"
              onClick={() => navigate("/dashboard")}
              className="text-white hover:bg-white/20 transition-colors"
            >
              <ArrowLeft className="h-4 w-4 mr-2" />
              Retour au dashboard
            </Button>
          </div>
          
          <div className="text-center text-white space-y-4">
            <Avatar className="h-24 w-24 mx-auto ring-4 ring-white/20 mb-4">
              <AvatarFallback className="bg-white/20 text-white text-2xl font-bold">
                {userInfo.firstName[0]}{userInfo.lastName[0]}
              </AvatarFallback>
            </Avatar>
            <h1 className="text-3xl font-bold">Mon Profil</h1>
            <p className="text-white/90">Informations personnelles et professionnelles</p>
          </div>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Informations personnelles */}
          <Card className="p-6 bg-gradient-card backdrop-blur-sm border-glass shadow-card">
            <h2 className="text-xl font-semibold text-foreground mb-6 flex items-center gap-2">
              <Mail className="h-5 w-5 text-primary" />
              Informations personnelles
            </h2>
            
            <div className="space-y-4">
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="text-sm font-medium text-muted-foreground">Prénom</label>
                  <p className="text-foreground font-medium">{userInfo.firstName}</p>
                </div>
                <div>
                  <label className="text-sm font-medium text-muted-foreground">Nom</label>
                  <p className="text-foreground font-medium">{userInfo.lastName}</p>
                </div>
              </div>
              
              <div>
                <label className="text-sm font-medium text-muted-foreground">Email professionnel</label>
                <p className="text-foreground font-medium">{userInfo.email}</p>
              </div>
              
              <div>
                <label className="text-sm font-medium text-muted-foreground flex items-center gap-1">
                  <Phone className="h-4 w-4" />
                  Téléphone
                </label>
                <p className="text-foreground font-medium">{userInfo.phone}</p>
              </div>
              
              <div>
                <label className="text-sm font-medium text-muted-foreground flex items-center gap-1">
                  <MapPin className="h-4 w-4" />
                  Adresse
                </label>
                <p className="text-foreground font-medium">{userInfo.address}</p>
              </div>
            </div>
          </Card>

          {/* Informations professionnelles */}
          <Card className="p-6 bg-gradient-card backdrop-blur-sm border-glass shadow-card">
            <h2 className="text-xl font-semibold text-foreground mb-6 flex items-center gap-2">
              <Briefcase className="h-5 w-5 text-primary" />
              Informations professionnelles
            </h2>
            
            <div className="space-y-4">
              <div>
                <label className="text-sm font-medium text-muted-foreground">Fonction</label>
                <p className="text-foreground font-medium">{userInfo.function}</p>
              </div>
              
              <div>
                <label className="text-sm font-medium text-muted-foreground">Département</label>
                <p className="text-foreground font-medium">{userInfo.department}</p>
              </div>
              
              <div>
                <label className="text-sm font-medium text-muted-foreground">ID Employé</label>
                <p className="text-foreground font-medium">{userInfo.employeeId}</p>
              </div>
              
              <div>
                <label className="text-sm font-medium text-muted-foreground flex items-center gap-1">
                  <Calendar className="h-4 w-4" />
                  Date d'entrée
                </label>
                <p className="text-foreground font-medium">{userInfo.startDate}</p>
              </div>
            </div>
          </Card>
        </div>

        {/* Actions */}
        <Card className="mt-8 p-6 bg-gradient-card backdrop-blur-sm border-glass shadow-card text-center">
          <h3 className="text-lg font-semibold text-foreground mb-4">
            Besoin de modifier vos informations ?
          </h3>
          <p className="text-muted-foreground mb-6">
            Contactez le service RH pour mettre à jour vos données personnelles ou professionnelles
          </p>
          <div className="flex items-center justify-center gap-2 text-primary">
            <Mail className="h-4 w-4" />
            <span className="text-sm font-medium">rh@dislogiq.com</span>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default Profile;